/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */
'use strict';

var Animated=require('./Animated');

function isAnimated(obj){
return obj instanceof Animated;}


module.exports=isAnimated;


//////////////////
// WEBPACK FOOTER
// /~/animated/lib/isAnimated.js
// module id = 255
// module chunks = 0